// Переключатель светлого и тёмного режима витрины.
//
// Выбор живёт в localStorage браузера покупателя — аккаунт не нужен, на сервер
// ничего не уходит. Доступ к хранилищу обёрнут в try/catch: в приватном окне
// и при заблокированных куках он бросает исключение.
(function () {
  // Защита от повторного подключения: два обработчика на один клик
  // переключали режим дважды подряд, и он возвращался обратно.
  if (window.__artmellioThemeToggle) return;
  window.__artmellioThemeToggle = true;

  var КЛЮЧ = 'artmellio:theme';

  function прочитать() {
    try {
      return localStorage.getItem(КЛЮЧ);
    } catch (e) {
      return null;
    }
  }

  function записать(режим) {
    try {
      localStorage.setItem(КЛЮЧ, режим);
    } catch (e) {
      /* приватный режим — выбор просто не запомнится */
    }
  }

  function применить(режим) {
    if (режим === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    document.querySelectorAll('[data-theme-toggle]').forEach(function (кнопка) {
      кнопка.setAttribute('aria-pressed', режим === 'light' ? 'true' : 'false');
    });
  }

  // Применяем сохранённый выбор до отрисовки, иначе на светлом режиме
  // мелькнёт тёмный фон.
  применить(прочитать() === 'dark' ? 'dark' : 'light');

  document.addEventListener('click', function (событие) {
    var кнопка = событие.target.closest('[data-theme-toggle]');
    if (!кнопка) return;
    var новый = document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    применить(новый);
    записать(новый);
  });
})();
